module.exports = __webpack_public_path__ + "img/shade-quote-logo.6a0a6ef6.png";